<template>
  <div>
<!--     <flexbox :gutter="0" style="height: 50px; background-color: #FFFFFF;">
      <flexbox-item :span="8">
        <span class="mx-3">
          <span>{{$t('cart.totalPrice')}}</span>
        <span style="color: red">{{$t('kol.priceUnit')}} {{getRoundPrice(getExchangePrice(totalPrice))}}</span>
        </span>
      </flexbox-item>
      <flexbox-item>
        <b-button variant="success" class="footer-button" block @click="openPaymentMethodList">{{$t('cart.order.create')}}</b-button>
      </flexbox-item>
    </flexbox> -->
    <b-row class="mx-0" :gutter="0" style="height: 50px; background-color: #FFFFFF;">
      <b-col class="px-0" cols="8">
        <span class="mx-3" style="line-height:  50px;">
          <span>{{$t('cart.totalPrice')}}</span>
          <span style="color: red">{{$t('kol.priceUnit')}} {{totalPrice}}</span>
        </span>
      </b-col>
      <b-col class="px-0" cols="4">
        <b-button v-if="disable==true" variant="success" class="footer-button3" :pressed.sync="alert"><span style="color:white; z-index: 200 !important; ">{{$t('cart.order.create')}}</span></b-button>
        <b-button v-else variant="success" class="footer-button3" @click="openPaymentMethodList"><span style="color:white; z-index: 200 !important; ">{{$t('cart.order.create')}}</span></b-button>
      </b-col>
      <div v-transfer-dom>
        <alert v-model="alert" title="提醒" :button-text="$t('general.confirm')"> 提交前請確保你已填寫地址(如適用)﹐聯絡電話及確認條款</alert>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import { Flexbox, FlexboxItem, XButton, Actionsheet, Alert, TransferDomDirective as TransferDom } from 'vux'
import { mapGetters } from 'vuex'

export default {
  name: 'CheckoutFooter',
  directives: {
    TransferDom
  },
  components: {
    Flexbox,
    FlexboxItem,
    Actionsheet,
    Alert,
  },
  props: {
    currency: String,
    totalPrice: Number,
    disable: Boolean
  },
  data() {
    return {
      alert: false
    }
  },
  created() {
    document.title = "網紅熱購";
  },
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters([
      'getExchangePrice',
      'getRoundPrice',
    ]),
  },
  methods: {
 
    openPaymentMethodList() {
      this.$emit('createOrder');
    },
    click(paymentMethod) {
      // this.$router.push('/cart/payment');
      switch (paymentMethod) {
        case 'W':
          this.$emit('pay', 'W');
          break;
        case 'S':
          this.$emit('pay', 'S');
          break;
        default:
          break;
      }
    }
  },
}

</script>
<style type="text/css" scoped>
.footer-button3 {
  height: 50px;
  width: 100%;
  border-radius: 0px;
  font-size: 20;
  z-index: 200;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/Package/components/CheckoutFooter.vue